import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export interface FuncionarioOption {
  id: number;
  nome: string;
  codigo_funcionario?: string;
  id_cargo?: number;
  creche_id: number;
}

export function useFuncionarios() {
  const [funcionarios, setFuncionarios] = useState<FuncionarioOption[]>([]);

  const carregarFuncionarios = useCallback(async () => {
    try {
      const { data } = await api.get<FuncionarioOption[]>('/funcionarios');
      setFuncionarios(data || []);
    } catch {
      setFuncionarios([]);
    }
  }, []);

  useEffect(() => {
    carregarFuncionarios();
  }, [carregarFuncionarios]);

  return { funcionarios, carregarFuncionarios };
}
